
import { BrandingData } from "admin-portal/settings/branding";
import { UserRole } from "../models/user/user-role"
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from "moment";

export class AppUtility {
    static round2Decimal = (no: number) => {

        return Math.round((no ?? 0) * 100) / 100
    }
    // Getter for dbKey property
    static displayNameForRole = (item: UserRole): string | undefined => {
        if (item.name) {
            return (item.name ?? "").toLocaleLowerCase().replace("tenant", BrandingData.bussinessDomain).toUpperCase();
        }
        return "";
    }

    static formikCurrencyValidtion = () => {
        return Yup.number()
            .nullable() // Allows the field to be null or empty
            .typeError("Must be a valid price") // Ensures input is a number
            .test("is-decimal-or-integer", "Must be a valid number with up to two decimal places", (val) => {
                var value = (val ?? "").toString();
                if (value === null || value === "") {
                    return true; // Allow empty values
                }
                // Check if it's a valid number with up to two decimal places
                return /^\d+(\.\d{1,2})?$/.test(value);
            });
    }

    static formikDateValidtion = () => {
        return Yup.date()
            .nullable() // Allows the field to be null or empty
            .default(null)
            .test("is-valid-date", "Invalid date format", function (value) {
                if (value === null) return true; // Allow null values
                return moment(value, true).isValid(); // Use moment.js to check if the date is valid
            })
    }



    static ISODateToISOString = (date: Date, dateOnly: boolean = false) => {
        // Create a Date object from the input string
        //const date = new Date(dateString);

        // Extract the year, month, day, hour, and minute
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getUTCDate()).padStart(2, '0');

        const hour = String(date.getUTCHours()).padStart(2, '0');
        const minute = String(date.getUTCMinutes()).padStart(2, '0');

        // Construct the desired ISO format without the timezone
        return dateOnly ? `${year}-${month}-${day}T00:00` : `${year}-${month}-${day}T${hour}:${minute}`;
    };
    static ISOStringToDate = (dateString: string) => {
        const _arr = dateString.split('T');
        const _date = _arr[0].split('-');
        const _time = _arr[1].split(':');
        // Create a Date object from the input string
        const date = new Date(_arr[0]);
        // date.setHours(parseInt(_time[0]))
        //date.setMinutes(parseInt(_time[1]))
        return date;
    };
    static ISOStringToDateOnlyString = (dateString: string) => {
        const _arr = dateString.split('T');

        return _arr[0];
    };
}